import { render, staticRenderFns } from "./BaseEmpty.vue?vue&type=template&id=2ffc166d&scoped=true&"
import script from "./BaseEmpty.vue?vue&type=script&lang=js&"
export * from "./BaseEmpty.vue?vue&type=script&lang=js&"
import style0 from "./BaseEmpty.vue?vue&type=style&index=0&id=2ffc166d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ffc166d",
  null
  
)

export default component.exports